import Households from '../views/Households';
import HouseholdsIndex from '../views/households/Index';
import HouseholdsView from '../views/households/View';
import HouseholdsIntake from '../views/households/Intake';

export const HOUSEHOLD_TOOLS = {
  path: '/households',
  component: Households,
  meta: { title: 'Households' },
  children: [
    {
      path: '',
      name: 'households',
      component: HouseholdsIndex,
      meta: { title: 'Households' }
    },
    {
      path: ':household_id',
      component: HouseholdsView,
      meta: { title: 'Household' },
      children: [
        {
          path: '',
          name: 'households-view',
          meta: { title: 'Household - Overview' },
        },
        {
          path: 'settings',
          name: 'households-settings',
          meta: { title: 'Household - Settings' }
        },
        {
          path: 'onboarding',
          name: 'households-onboarding',
          meta: { title: 'Household - Onboarding' }
        },
        {
          path: 'freedom-accelerator',
          name: 'households-prd-freedom-accelerator',
          meta: { title: 'Household - Freedom Accelerator' }
        },
        {
          path: 'liabilities/:debt_action?/:debt_id?',
          name: 'households-debts',
          meta: { title: 'Household - Liabilities' }
        },
        {
          path: 'policies/:policy_action?/:policy_id?',
          name: 'households-policies',
          meta: { title: 'Household - Policies' }
        },
        {
          path: 'mortgage-enhancer',
          name: 'households-mortgage-enhancer',
          meta: { title: 'Household - Mortgage Enhancer' }
        }
      ]
    },
    {
      path: ':household_id/intake',
      component: HouseholdsIntake,
      name: 'households-intake',
      meta: { title: 'Household - Intake Form' }
    }
  ]
};
